<template>
  <div>
    <a href="#/" class="btn btn-success mb-2 text-nowrap" @click="showModal()">Complete Project</a>

    <b-modal id="complete-project-modal" hide-footer>
      <template #modal-title>Complete Project</template>

      <div class="row text-white">
        <div class="col">
            <label class="form-label pt-0 mb-0" for="dealer-name">Is this project complete?</label>
            <div class="mb-2"><small>We'll let the service provider know</small></div>
        </div>
      </div>

      <div class="row text-white">
        <div class="col">
            <label class="form-label pt-0 mb-0" for="dealer-name">Note</label>
            <div class="mb-2"><small>Anything you want to say to the service provider</small></div>
            <textarea class="form-control shadow-none inputbox" rows="3" v-model="note"></textarea>
        </div>
      </div>

      <div class="row pt-3 pb-2">
        <div class="col">
<button v-if="updating" type="button" class="btn btn-success submit col">
  <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
        <button v-else type="button" class="btn btn-success submit col" @click="completeProject">Complete Project</button>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
export default {
  props: ['project'],

  data() {
    return {
      note: null,
      updating: false,
      projectInfo: null,
    };
  },

  created() {
    
  },

  methods: {

    showModal() {
      this.$bvModal.show("complete-project-modal");
    },

    hideModal() {
      this.$bvModal.hide("complete-project-modal");
    },

    completeProject() {

          this.updating = true;

          axios.post('/projects/complete-project', {
            project_id: this.project.id, 
            note: this.note})
        .then((response) => {
          this.hideModal();
          this.updating = false;
          this.projectInfo = response.data;
          this.showToaster('Project completed');
        });

      },

      showToaster(text) {
      this.$toaster.success(text, { timeout: 2500 });
      },

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },
  },
};
</script>

<style scoped>
select.form-select {
  background-color: #ffffff !important;
  border: 2px solid #35363a;
}

.input-group-text.price {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    padding-left: 1.0rem;
}

input.form-control.price {
    padding-left: 0rem;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 5px !important;
    }

.btn.btn-success.submit, .btn.btn-dark.submit, .btn.btn-secondary.submit {
    border-radius: 5px !important;
}
</style>